import { z } from "zod";

import { MESSAGE_TYPE, SENDER_TYPE } from "@/constants/message";
import { adminSchema } from "@/schemas/admin";
import { profileSchema } from "@/schemas/profile";

const baseMessageSchema = z.object({
  id: z.number(),
  threadId: z.number(),
  type: z.nativeEnum(MESSAGE_TYPE),
  content: z.string(),
  metadata: z.record(z.string(), z.unknown()),
  createdAt: z.string(),
});

export const messageSchema = z.discriminatedUnion("senderType", [
  baseMessageSchema.extend({
    senderType: z.literal(SENDER_TYPE.user),
    sender: profileSchema,
  }),
  baseMessageSchema.extend({
    senderType: z.literal(SENDER_TYPE.admin),
    sender: adminSchema,
  }),
  baseMessageSchema.extend({
    senderType: z.literal(SENDER_TYPE.system),
    sender: z.null(),
  }),
]);

export const createMessageRequestSchema = z.object({
  content: z.string().trim().min(1, { message: "Write a message before sending" }),
});
